import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.module.css';

const MaxButton = ({ onClick, disabled, label }) => {
  const handleClick = (evt) => {
    evt.preventDefault();
    if (!disabled && onClick) {
      onClick(evt);
    }
  };

  return (
    <button
      type="button"
      className={classNames(styles.root, { [styles.disabled]: disabled })}
      onClick={handleClick}
      disabled={disabled}
      aria-label={label}
    >
      {label}
    </button>
  );
};

MaxButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

MaxButton.defaultProps = {
  disabled: false,
  label: 'Max',
};

export default MaxButton;
